import { Link } from "react-router-dom";
import { Home, ArrowRight } from "lucide-react";
import { SEO } from "@/components/SEO";
import { routes, navLinks } from "@/lib/site";

export default function NotFound() {
  return (
    <>
      <SEO path="/404" title="Page Not Found | Dr. Satyam Jaiswal Chiropractor Varanasi" description="The page you are looking for could not be found." />
      <section className="relative overflow-hidden bg-navy min-h-[70vh] grid place-items-center">
        <div className="absolute inset-0 hero-glow" />
        <div className="absolute inset-0 dotted-grid opacity-30" />
        <div className="relative text-center px-4 max-w-lg">
          <p className="font-heading font-extrabold text-brand-orange text-7xl sm:text-8xl">404</p>
          <h1 className="mt-4 font-heading font-bold text-white text-2xl sm:text-3xl">Page Not Found</h1>
          <p className="mt-3 text-white/70">The page you're looking for doesn't exist or may have moved.</p>
          <Link to={routes.home} data-testid="notfound-home-link" className="mt-8 inline-flex items-center gap-2 rounded-full bg-brand-orange px-7 py-3.5 font-bold text-white hover:bg-brand-orange-dark transition-colors">
            <Home className="h-5 w-5" /> Back to Home
          </Link>
          <div className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2">
            {navLinks.slice(1).map((l) => (
              <Link key={l.to} to={l.to} className="inline-flex items-center gap-1 text-sm text-white/70 hover:text-brand-orange transition-colors">
                {l.label} <ArrowRight className="h-3 w-3" />
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
